















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { FormLabel } from '@/models/Form';
import { mapGetters } from 'vuex';
import { BFormInput, BModal } from 'bootstrap-vue';
import BaseInputColor from '@/components/BaseInputColor.vue';

@Component({
    name: 'ModalFormLabelUpdate',
    components: {
        'b-modal': BModal,
        'b-form-input': BFormInput,
        'base-input-color': BaseInputColor,
    },
    computed: mapGetters({
        formLabels: 'formLabels/all',
    }),
})
export default class ModalFormLabelUpdate extends Vue {
    title = '';
    hex = '';

    formLabels!: FormLabel[];

    updating = false;
    error = '';
    invalidTitle = false;
    missingTitle = false;

    @Prop() label!: FormLabel;

    reset() {
        this.error = '';
        this.title = this.label.title;
        this.hex = this.label.hex;
        this.updating = false;
    }

    onInput() {
        this.missingTitle = this.title === '';
        for (const key in this.formLabels) {
            if (this.formLabels[key].title === this.title && this.formLabels[key].id !== this.label.id) {
                this.invalidTitle = true;
                break;
            } else {
                this.invalidTitle = false;
            }
        }
    }

    async update() {
        this.updating = true;
        try {
            await this.$store.dispatch('formLabels/update', {
                id: this.label.id,
                title: this.title,
                hex: this.hex,
            });
            this.$bvModal.hide(`modalFormLabelUpdate-${this.label.id}`);
        } catch (error) {
            this.error = error;
        } finally {
            this.updating = false;
        }
    }
}
